import React from 'react';
import Colors from '@data/enums/Color.enum';

export function sesame({ fill = Colors.TEXT_DEFAULT }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.74074 12.7L10.5185 13.3C10.5185 13.3 14.963 12.4 15.5556 12.4C16.1481 12.4 16.1481 13 15.5556 13.6C14.963 14.2 12.8889 16 11.1111 16C9.33333 16 8.14815 15.1 6.96296 15.1H4'
        stroke={fill} strokeLinecap='round' strokeLinejoin='round' />
      <path d='M4 11.5C4.59259 10.9 5.77778 10 6.96296 10C8.14815 10 10.963 11.2 11.4074 11.8C11.8519 12.4 10.5185 13.3 10.5185 13.3'
        stroke={fill} strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12.8889 10.3C13.3798 10.3 13.7778 9.89706 13.7778 9.4C13.7778 8.90294 13.3798 8.5 12.8889 8.5C12.398 8.5 12 8.90294 12 9.4C12 9.89706 12.398 10.3 12.8889 10.3Z'
        fill={fill} stroke={fill} />
      <path d='M9.33322 8.20003C9.82414 8.20003 10.2221 7.79708 10.2221 7.30003C10.2221 6.80297 9.82414 6.40002 9.33322 6.40002C8.84231 6.40002 8.44434 6.80297 8.44434 7.30003C8.44434 7.79708 8.84231 8.20003 9.33322 8.20003Z'
        fill={fill} stroke={fill} />
      <path d='M12.8889 5.8C13.3798 5.8 13.7778 5.39706 13.7778 4.9C13.7778 4.40294 13.3798 4 12.8889 4C12.398 4 12 4.40294 12 4.9C12 5.39706 12.398 5.8 12.8889 5.8Z'
        fill={fill} stroke={fill} />
    </svg>
  );
}

